import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["trigger", "content"]
  static values = { persistKey: String, defaultTab: String }

  connect() {
    const savedTab = this.hasDefaultTabValue ? this.defaultTabValue : this.getSavedTab()
    if (savedTab) {
      this.activateTab(savedTab)
    }
  }

  switchTab(event) {
    const clickedTab = event.currentTarget.dataset.tab
    this.activateTab(clickedTab)
    this.saveTab(clickedTab)
  }

  activateTab(tab) {
    // Update trigger states
    this.triggerTargets.forEach(trigger => {
      const isActive = trigger.dataset.tab === tab

      if (isActive) {
        trigger.classList.remove("bg-white", "rounded-lg", "text-[#6b7280]")
        trigger.classList.add("bg-[#f2f3f5]", "rounded-md", "text-[#1f2937]")
      } else {
        trigger.classList.remove("bg-[#f2f3f5]", "rounded-md", "text-[#1f2937]")
        trigger.classList.add("bg-white", "rounded-lg", "text-[#6b7280]")
      }
    })

    // Update content visibility
    this.contentTargets.forEach(content => {
      const isActive = content.dataset.tab === tab

      if (isActive) {
        content.classList.remove("hidden")
        content.classList.add("flex")
      } else {
        content.classList.remove("flex")
        content.classList.add("hidden")
      }
    })

    // Hide/show activity template sidebar based on tab
    this.toggleActivityTemplateSidebar(tab)
  }

  getSavedTab() {
    if (!this.hasPersistKeyValue || !this.persistKeyValue) return null
    const saved = localStorage.getItem(this.persistKeyValue)
    if (!saved) return null
    const valid = this.triggerTargets.find(t => t.dataset.tab === saved)
    return valid ? saved : null
  }

  saveTab(tab) {
    if (!this.hasPersistKeyValue || !this.persistKeyValue) return
    localStorage.setItem(this.persistKeyValue, tab)
  }

  toggleActivityTemplateSidebar(activeTab) {
    // Find all activity template sidebars in the current context
    const templateSidebars = this.element.querySelectorAll('[data-activity-template-sidebar]')
    const phasesSidebars = this.element.querySelectorAll('[data-phases-sidebar]')

    // Hide/show activity template sidebar
    templateSidebars.forEach(sidebar => {
      if (activeTab === 'map') {
        sidebar.classList.add('hidden')
        sidebar.classList.remove('flex', 'lg:flex')
      } else {
        // Restore original responsive classes: hidden on small, flex on large
        sidebar.classList.add('hidden', 'lg:flex')
      }
    })

    // Hide/show phases sidebar
    phasesSidebars.forEach(sidebar => {
      if (activeTab === 'map') {
        sidebar.classList.add('hidden')
        sidebar.classList.remove('flex', 'lg:flex')
      } else {
        // Restore original responsive classes: hidden on small, flex on large
        sidebar.classList.add('hidden', 'lg:flex')
      }
    })
  }
}
